/* himedi-lb-flow.js — less-busy staging (2026-10-14, flow lane). Loaded at the end of sections/himedi-checkup-build.liquid
 * and sections/himedi-checkup-summary.liquid, without defer, after the live flow files.
 *
 * WHAT THIS IS. The approved draft (runs/2026-10-14-html-preview/preview/{builder,date}.html) is a picture: its own
 * script kept a fake build in localStorage. Here the same markup and motion are bound to the LIVE flow:
 *   - every state read goes through window.HimediFlow (himedi-checkup-flow.js): state(), baseKey(), total(),
 *     isCovered(), upgradeAvailable(), catalog();
 *   - every change is a click on the live control the flow file wired (.baseopt, .upcard .addbtn, .addon .atoggle in
 *     the hidden .lb-model / .cf-ab-rows), so saving, the footer total, the cover rule and the cart stay the live code's;
 *   - the date step keeps the booking app, himedi-summary-edit.js (the edit card), himedi-summary-next-step.js (Add to
 *     Cart, pinned bar) and the held box; this file only moves their nodes into the draft's summary card and animates.
 * Nothing here writes localStorage, the cart or a price.
 *
 * MOTION (runs/2026-10-14-html-preview/MOTION.md). Durations come from the CSS tokens; --dur-swap:0ms snaps
 * everything (that is the frame recorders' planted failure).
 */
(function () {
  'use strict';
  var D = document, H = D.documentElement;
  function $(s, r) { return (r || D).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || D).querySelectorAll(s)); }
  function el(tag, cls, text) { var e = D.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
  function money(n) { return '$' + Number(n || 0).toLocaleString('en-US'); }
  var PLUS = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 5v14M5 12h14"></path></svg>';
  var I_PL = '<svg class="d-i-pl" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 5v14M5 12h14"></path></svg>';
  var I_CK = '<svg class="d-i-chk" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6L9 17l-5-5"></path></svg>';

  /* ---------------- motion helpers (the draft's, unchanged in behaviour) ---------------- */
  var RMQ = window.matchMedia('(prefers-reduced-motion: reduce)');
  var ready = false;
  function cssv(n) { return getComputedStyle(D.body).getPropertyValue(n).trim(); }
  /* Shopify minifies asset CSS (280ms is served as .28s), so read the unit. */
  function msv(n, d) { var raw = cssv(n), v = parseFloat(raw); if (isNaN(v)) return d; return /ms$/i.test(raw) ? v : (/s$/i.test(raw) ? v * 1000 : v); }
  function T() {
    var rm = RMQ.matches;
    return { rm: rm,
      swap: rm ? 150 : msv('--dur-swap', 280), ui: rm ? 150 : msv('--dur-ui', 220), exit: rm ? 150 : msv('--dur-exit', 160),
      off: !ready || (!rm && msv('--dur-swap', 280) <= 0),
      easeOut: cssv('--ease-out') || 'ease-out', easeIO: cssv('--ease-in-out') || 'ease-in-out' };
  }
  function cancelA(e, k) { var m = e._m; if (m && m[k]) { m[k].cancel(); delete m[k]; } }
  /* one named animation per element; a new one replaces the old from where the old one is */
  function run(e, k, kf, opt, done) {
    cancelA(e, k); if (!e._m) e._m = {};
    var a = e.animate(kf, opt); e._m[k] = a;
    a.onfinish = function () {
      if (opt.fill !== 'forwards') { if (e._m[k] === a) delete e._m[k]; a.cancel(); }
      if (done) done();
    };
    return a;
  }
  function tY(px, t) { return t.rm || !px ? 'none' : 'translateY(' + px + 'px)'; }
  function curOp(e) { var v = parseFloat(getComputedStyle(e).opacity); return isNaN(v) ? 1 : v; }
  function unghost(e) {
    e.classList.remove('d-ghost'); e.style.left = e.style.top = e.style.width = e.style.height = '';
    e.removeAttribute('aria-hidden');
    if (e._k != null && e.getAttribute('data-focus') == null) e.setAttribute('data-focus', e._k);
  }
  function isShown(e) { return !e.hidden && !e.classList.contains('d-ghost'); }
  function showEl(e) { cancelA(e, 'out'); if (e.classList.contains('d-ghost')) unghost(e); e.hidden = false; }
  /* Swap one set of elements for another inside `group`: the leaving ones fade out as overlays (--dur-exit), the
     arriving ones enter with opacity + translateY(8px), 60ms apart, and the group height tweens old -> new. */
  function swapSets(group, all, ins, o) {
    o = o || {}; var t = T();
    var outs = all.filter(function (e) { return isShown(e) && ins.indexOf(e) < 0; });
    var inNew = ins.filter(function (e) { return !isShown(e); });
    if (!outs.length && !inNew.length) return;
    if (t.off || !group.animate) {
      outs.forEach(function (e) { cancelA(e, 'out'); cancelA(e, 'in'); e.hidden = true; });
      inNew.forEach(function (e) { cancelA(e, 'in'); showEl(e); });
      cancelA(group, 'h'); if (o.prepare) o.prepare(); return;
    }
    var h0 = group.getBoundingClientRect().height;
    var info = outs.map(function (e) { return { e: e, l: e.offsetLeft, t: e.offsetTop, w: e.offsetWidth, h: e.offsetHeight, op: curOp(e) }; });
    var starts = inNew.map(function (e) { return e.classList.contains('d-ghost') ? curOp(e) : 0; });
    cancelA(group, 'h');
    info.forEach(function (g) {
      var e = g.e; cancelA(e, 'in');
      e.classList.add('d-ghost'); e.setAttribute('aria-hidden', 'true');
      if (e.getAttribute('data-focus') != null) e.removeAttribute('data-focus');
      e.style.left = g.l + 'px'; e.style.top = g.t + 'px'; e.style.width = g.w + 'px'; e.style.height = g.h + 'px';
      run(e, 'out', [{ opacity: g.op }, { opacity: 0 }], { duration: t.exit, easing: 'linear', fill: 'forwards' }, function () { e.hidden = true; unghost(e); });
    });
    inNew.forEach(function (e) { showEl(e); });
    if (o.prepare) o.prepare();
    var h1 = group.getBoundingClientRect().height;
    inNew.forEach(function (e, i) {
      var s = starts[i];
      run(e, 'in', [{ opacity: s, transform: tY(8 * (1 - s), t) }, { opacity: 1, transform: 'none' }],
        { duration: t.swap, delay: t.rm ? 0 : (o.delay == null ? 80 : o.delay) + i * 60, easing: t.easeOut, fill: 'backwards' });
    });
    if (!t.rm && Math.abs(h1 - h0) > 0.5) {
      run(group, 'h', [{ height: h0 + 'px', clipPath: 'inset(-40px -40px 0px -40px)' }, { height: h1 + 'px', clipPath: 'inset(-40px -40px -32px -40px)' }],
        { duration: t.swap, easing: t.easeIO });
    }
  }
  /* Show or hide one block with a height tween (padding tweens with it); `done` runs when it has settled. */
  function collapse(e, show, instant, done) {
    var t = T(), off = e.classList.contains('d-off');
    if (instant || t.off || t.rm || !e.animate) {
      cancelA(e, 'h'); cancelA(e, 'o'); e.style.overflow = ''; e.classList.toggle('d-off', !show); if (done) done(); return;
    }
    var cs0 = getComputedStyle(e);
    var h0 = off ? 0 : e.getBoundingClientRect().height, op0 = off ? 0 : curOp(e);
    var pt0 = off ? 0 : parseFloat(cs0.paddingTop), pb0 = off ? 0 : parseFloat(cs0.paddingBottom);
    cancelA(e, 'h'); cancelA(e, 'o');
    e.style.overflow = 'hidden';
    var fin = function () { e.style.overflow = ''; if (done) done(); };
    if (show) {
      e.classList.remove('d-off');
      var h1 = e.getBoundingClientRect().height, cs = getComputedStyle(e);
      var pt1 = parseFloat(cs.paddingTop), pb1 = parseFloat(cs.paddingBottom);
      if (h1 <= 0) { fin(); return; }
      run(e, 'h', [{ height: h0 + 'px', paddingTop: pt0 + 'px', paddingBottom: pb0 + 'px' }, { height: h1 + 'px', paddingTop: pt1 + 'px', paddingBottom: pb1 + 'px' }], { duration: t.swap, easing: t.easeIO }, fin);
      run(e, 'o', [{ opacity: op0, transform: tY(6 * (1 - op0), t) }, { opacity: 1, transform: 'none' }], { duration: t.swap, easing: t.easeOut });
    } else {
      if (h0 <= 0) { e.classList.add('d-off'); fin(); return; }
      run(e, 'h', [{ height: h0 + 'px', paddingTop: pt0 + 'px', paddingBottom: pb0 + 'px' }, { height: '0px', paddingTop: '0px', paddingBottom: '0px' }], { duration: t.swap, easing: t.easeIO, fill: 'forwards' }, function () { e.classList.add('d-off'); fin(); });
      run(e, 'o', [{ opacity: op0, transform: 'none' }, { opacity: 0, transform: tY(6, t) }], { duration: t.exit, easing: 'linear', fill: 'forwards' });
    }
  }
  /* A number never jumps: the old value is a ghost that fades and rises 6px, the new one comes in from below.
     ghostNum() is for text something else already changed (the live footer total); swapText() changes it itself. */
  function ghostNum(e, old, anchor) {
    var t = T(); if (t.off || !e.animate || old === e.textContent) return;
    var par = e.offsetParent || e.parentElement; if (!par) return;
    if (e._g) { e._g.remove(); e._g = null; }
    var g = D.createElement('span'); g.className = 'd-gv'; g.setAttribute('aria-hidden', 'true'); g.textContent = old;
    var cs = getComputedStyle(e);
    g.style.fontFamily = cs.fontFamily; g.style.fontSize = cs.fontSize; g.style.fontWeight = cs.fontWeight; g.style.lineHeight = cs.lineHeight; g.style.letterSpacing = cs.letterSpacing; g.style.color = cs.color;
    g.style.top = e.offsetTop + 'px';
    if (anchor === 'right') g.style.right = (par.clientWidth - e.offsetLeft - e.offsetWidth) + 'px'; else g.style.left = e.offsetLeft + 'px';
    par.appendChild(g); e._g = g;
    var dy = t.rm ? 0 : 6;
    var a = g.animate([{ opacity: 1, transform: 'none' }, { opacity: 0, transform: tY(-dy, t) }], { duration: t.ui, easing: t.easeOut, fill: 'forwards' });
    a.onfinish = function () { g.remove(); if (e._g === g) e._g = null; };
    run(e, 'n', [{ opacity: 0, transform: tY(dy, t) }, { opacity: 1, transform: 'none' }], { duration: t.ui, easing: t.easeOut });
  }
  function swapText(e, txt, anchor) { var old = e.textContent; if (old === txt) return; e.textContent = txt; ghostNum(e, old, anchor); }
  /* Height of a container that something else re-renders: tween from the last settled height to the new one. */
  function heightTween(e, h0) {
    var t = T(); if (t.off || t.rm || !e.animate || h0 == null) return;
    var h1 = e.getBoundingClientRect().height;
    if (Math.abs(h1 - h0) <= 0.5) return;
    run(e, 'h', [{ height: h0 + 'px', overflow: 'hidden' }, { height: h1 + 'px', overflow: 'hidden' }], { duration: t.swap, easing: t.easeIO });
  }
  function onFlowReady(fn) {
    var F = window.HimediFlow;
    if (F && F.ready) { fn(); return; }
    var done = false, go = function () { if (done) return; done = true; fn(); };
    D.addEventListener('himedi:flow-ready', go);
    D.addEventListener('DOMContentLoaded', go);
  }
  function onArm(fn) { var AB = window.HimediAB; if (AB && AB.onArm && typeof AB.onArm.push === 'function') AB.onArm.push(fn); }

  /* ---------------- "What's included" sheet: modal on desktop, bottom sheet on phones ---------------- */
  var sheet = null, sbody, stitle, sx, opener = null;
  function sheetInit() {
    if (sheet) return;
    sheet = el('div', 'd-sheet'); sheet.setAttribute('role', 'dialog'); sheet.setAttribute('aria-modal', 'true'); sheet.setAttribute('aria-labelledby', 'd-sheet-t');
    sheet.innerHTML = '<div class="d-scrim"></div><div class="d-sp"><div class="d-sh"><div><h2 class="d-h2" id="d-sheet-t">What’s included</h2><span class="d-small"></span></div><button class="d-sx" type="button" aria-label="Close"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"></path></svg></button></div><div class="d-sb"></div></div>';
    D.body.appendChild(sheet);
    sbody = $('.d-sb', sheet); stitle = $('.d-sh .d-small', sheet); sx = $('.d-sx', sheet);
    sx.addEventListener('click', closeSheet);
    $('.d-scrim', sheet).addEventListener('click', closeSheet);
    D.addEventListener('keydown', function (e) {
      if (!sheet.classList.contains('open')) return;
      if (e.key === 'Escape') { e.preventDefault(); closeSheet(); }
      else if (e.key === 'Tab') { e.preventDefault(); sx.focus(); } /* the close button is the only control */
    });
  }
  /* The groups come from the page's own contents list (.lb-model .base-body), never from this file. */
  function openSheet(body, title, from) {
    if (!body) return;
    sheetInit();
    opener = from || null;
    stitle.textContent = title;
    sbody.textContent = ''; sbody.scrollTop = 0;
    $$('.fgroup', body).forEach(function (g) {
      var cats = $$('.fcat', g);
      var box = el('section', 'd-sg');
      box.appendChild(el('span', 'd-eyebrow d-sgh', ((($('.gn', g) || {}).textContent) || '').trim() + ' (' + cats.length + ')'));
      cats.forEach(function (c) {
        var row = el('div', 'd-sr1');
        row.appendChild(el('b', null, ((($('b', c) || {}).textContent) || '').trim()));
        row.appendChild(el('span', null, ((($('span', c) || {}).textContent) || '').trim()));
        box.appendChild(row);
      });
      sbody.appendChild(box);
    });
    sheet.classList.add('open');
    H.classList.add('d-lock');
    sx.focus({ preventScroll: true });
  }
  function closeSheet() {
    if (!sheet || !sheet.classList.contains('open')) return;
    sheet.classList.remove('open');
    H.classList.remove('d-lock');
    if (opener && opener.focus) opener.focus({ preventScroll: true });
  }

  /* ======================================================================================
     BUILDER
     ====================================================================================== */
  function builder(B) {
    var F = window.HimediFlow;
    if (!F || typeof F.state !== 'function' || typeof F.catalog !== 'function' || typeof F.total !== 'function') { H.classList.add('lb-go'); return; }
    var model = $('.lb-model');
    var bases = $$('.d-base', B);
    var focusWrap = $('.d-focus', B);
    var cards = $$('.d-focus > .d-fc:not(.d-one)', B);
    var one = $('.d-one', B);
    var note = $('.d-note', B);
    var testsWrap = $('#lbTests', B), mRows = $('.cf-ab-rows', B);
    var sum = $('.d-sum', B), sumHr = sum && $('.d-hr', sum), totAside = sum && $('.d-tot .d-h2', sum);
    var foot = D.getElementById('footTotal');
    cards.forEach(function (c) { c._k = c.getAttribute('data-k'); });
    if (one) one._k = 'mri';

    /* ---- the live state, as the draft's view needs it ---- */
    function view() {
      var s = F.state(), b = F.baseKey(), up = s.upgrades || {};
      return {
        base: b,
        focus: ['heart', 'brain', 'cancer'].filter(function (k) { return up[k] && F.upgradeAvailable(k); }),
        mri: b === 'wbmri' && !!up.checkup && F.upgradeAvailable('checkup')
      };
    }
    function modelRow(id) { return mRows ? $('.addon[data-id="' + id + '"]', mRows) : null; }
    function rows() {
      var s = F.state(), c = F.catalog(), b = F.baseKey(), r = [];
      r.push(['base:' + b, c.BASES[b].name, c.BASES[b].price]);
      Object.keys(c.UPGRADES).forEach(function (k) {
        if (s.upgrades && s.upgrades[k] && F.upgradeAvailable(k)) r.push(['up:' + k, k === 'checkup' ? 'Baseline checkup' : c.UPGRADES[k].name + ' focus area', c.UPGRADES[k].price]);
      });
      Object.keys(c.ADDONS).forEach(function (k) {
        var a = c.ADDONS[k];
        if (!(s.addons && s.addons[k]) || !a.price || F.isCovered(k)) return;
        var n = modelRow(k); n = n && $('.an b', n);
        r.push(['ad:' + k, n ? n.textContent.trim() : a.name, a.price]);
      });
      return r;
    }

    /* ---- changes: always the live control's own click ---- */
    function fire(node) { if (node) node.click(); render(); }
    function setBase(k) { if (view().base === k) return; fire($('.baseopt[data-base="' + k + '"]', model)); }
    function toggleFocus(k) { fire($('.upcard[data-id="' + k + '"] .addbtn', model)); }

    /* ---- base cards (a radio group) ---- */
    bases.forEach(function (b, i) {
      var k = b.getAttribute('data-base');
      b.addEventListener('click', function (e) { if (e.target.closest('.d-pill')) return; setBase(k); });
      b.addEventListener('keydown', function (e) {
        if (e.target !== b) return;
        var key = e.key;
        if (key === 'Enter' || key === ' ') { e.preventDefault(); setBase(k); }
        else if (/^Arrow(Right|Down|Left|Up)$/.test(key)) {
          e.preventDefault();
          var n = (i + (key === 'ArrowRight' || key === 'ArrowDown' ? 1 : bases.length - 1)) % bases.length;
          setBase(bases[n].getAttribute('data-base')); bases[n].focus();
        }
      });
    });
    function sheetFor(k, from) {
      var body = $('.base-body[data-base="' + k + '"]', model);
      var card = $('.d-base[data-base="' + k + '"] .d-bn', B);
      openSheet(body, card ? card.textContent.trim() : '', from);
    }
    $$('[data-sheet]', B).forEach(function (p) {
      p.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); sheetFor(p.getAttribute('data-sheet'), p); });
    });

    /* ---- focus cards ---- */
    function wrapLabel(btn) { var bl = $('.d-bl', btn); btn._off = bl.innerHTML; }
    function togglePan(pan, inc) {
      var willOpen = pan.getAttribute('data-open') !== '1', t = T();
      pan.setAttribute('data-open', willOpen ? '1' : '0');
      inc.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      var chips = $$('.d-chip', pan);
      if (t.off || !pan.animate) { pan.setAttribute('data-vis', willOpen ? '1' : '0'); return; }
      if (t.rm) {
        pan.setAttribute('data-vis', willOpen ? '1' : '0');
        if (willOpen) run(pan, 'o', [{ opacity: 0 }, { opacity: 1 }], { duration: t.ui });
        return;
      }
      var h0 = pan.getBoundingClientRect().height;
      cancelA(pan, 'h');
      if (willOpen) {
        pan.setAttribute('data-vis', '1');
        var h1 = pan.getBoundingClientRect().height;
        run(pan, 'h', [{ height: h0 + 'px' }, { height: h1 + 'px' }], { duration: t.swap, easing: t.easeIO });
        chips.forEach(function (c, i) {
          run(c, 'in', [{ opacity: 0, transform: tY(6, t) }, { opacity: 1, transform: 'none' }], { duration: t.swap, delay: 60 + i * 40, easing: t.easeOut, fill: 'backwards' });
        });
      } else {
        run(pan, 'h', [{ height: h0 + 'px' }, { height: '0px' }], { duration: t.swap, easing: t.easeIO, fill: 'forwards' }, function () {
          cancelA(pan, 'h');
          if (pan.getAttribute('data-open') !== '1') pan.setAttribute('data-vis', '0');
        });
      }
    }
    cards.forEach(function (c) {
      var k = c._k, add = $('.d-add', c), inc = $('.d-inc', c), pan = $('.d-pan', c);
      wrapLabel(add);
      add.addEventListener('click', function () { toggleFocus(k); });
      if (inc && pan) inc.addEventListener('click', function () { togglePan(pan, inc); });
    });
    if (one) {
      wrapLabel($('.d-add', one));
      $('.d-add', one).addEventListener('click', function () { toggleFocus('checkup'); });
      var oneInc = $('.d-inc', one);
      if (oneInc) oneInc.addEventListener('click', function () { sheetFor('baseline', oneInc); });
    }
    /* the whole card adds or removes, as on live (2026-09-22); its buttons and open list keep their own job */
    cards.concat(one ? [one] : []).forEach(function (c) {
      c.addEventListener('click', function (e) {
        if (c.classList.contains('d-ghost') || e.target.closest('button, a, .d-pan')) return;
        toggleFocus(c === one ? 'checkup' : c._k);
      });
    });
    function setLabel(btn, html, state, host) {
      var bl = $('.d-bl', btn);
      if (bl.getAttribute('data-s') === state) return;
      var had = bl.getAttribute('data-s') != null, old = bl.innerHTML;
      bl.setAttribute('data-s', state);
      var t = T();
      if (had && !t.off && btn.animate) {
        var cs = getComputedStyle(btn);
        var g = D.createElement('span'); g.className = 'd-bl-ghost'; g.setAttribute('aria-hidden', 'true'); g.innerHTML = old;
        g.style.left = btn.offsetLeft + 'px'; g.style.top = btn.offsetTop + 'px'; g.style.width = btn.offsetWidth + 'px'; g.style.height = btn.offsetHeight + 'px';
        g.style.fontFamily = cs.fontFamily; g.style.fontSize = cs.fontSize; g.style.fontWeight = cs.fontWeight; g.style.lineHeight = cs.lineHeight; g.style.color = cs.color;
        host.appendChild(g);
        var a = g.animate([{ opacity: 1 }, { opacity: 0 }], { duration: t.exit, easing: 'linear', fill: 'forwards' });
        a.onfinish = function () { g.remove(); };
        bl.innerHTML = html;
        run(bl, 'in', [{ opacity: 0, transform: tY(6, t) }, { opacity: 1, transform: 'none' }], { duration: t.ui, delay: t.rm ? 0 : 40, easing: t.easeOut, fill: 'backwards' });
      } else bl.innerHTML = html;
    }
    function paint(card, on) {
      if (!card) return;
      var add = $('.d-add', card);
      setLabel(add, on ? '✓ Added' : add._off, on ? 'on' : 'off', $('.d-acts', card));
      card.classList.toggle('on', on);
      add.setAttribute('aria-pressed', on ? 'true' : 'false');
    }
    /* the three descriptions share one height so the buttons line up, without stretching a card that opens */
    function eqDesc() {
      focusWrap.style.removeProperty('--desc-h');
      if (!window.matchMedia('(min-width:1160px)').matches) return;
      var m = 0;
      cards.forEach(function (c) { if (isShown(c)) m = Math.max(m, $('.d-desc', c).getBoundingClientRect().height); });
      if (m) focusWrap.style.setProperty('--desc-h', m + 'px');
    }
    var shownWB = null;
    function setFocusSet(wb) {
      if (shownWB === null || !ready) {
        if (wb === shownWB) return;
        cards.forEach(function (c) { c.hidden = wb; }); if (one) one.hidden = !wb; shownWB = wb;
        focusWrap.classList.toggle('one', wb);
        if (note) collapse(note, !wb, true);
        return;
      }
      if (wb === shownWB) return;
      shownWB = wb;
      focusWrap.classList.toggle('one', wb);
      swapSets(focusWrap, cards.concat(one ? [one] : []), wb ? [one] : cards, { prepare: eqDesc });
      if (note) collapse(note, !wb);
    }

    /* ---- single tests: drawn from the add-on page's own rows (hidden, wired by HimediFlow.wireAddons) ---- */
    var testsBuilt = false;
    function buildTests() {
      var frag = D.createDocumentFragment();
      if (!mRows) return frag;
      $$('.addon-group', mRows).forEach(function (g) {
        var list = $$('.addon', g);
        if (g.hidden || !list.length) return;
        /* the category label sits above its box with the row count (Gabe's final edit, 2026-10-14); the box holds the rows */
        var cat = el('div', 'd-cat'), lab = el('span', 'd-eyebrow', ((($('.gh', g) || {}).textContent) || '').trim() + ' ');
        lab.appendChild(el('span', 'd-cnt', '· ' + list.length));
        cat.appendChild(lab);
        var box = el('div', 'd-card d-box'); cat.appendChild(box);
        list.forEach(function (a) {
          var id = a.getAttribute('data-id'), nm = ((($('.an b', a) || {}).textContent) || '').trim();
          var r = el('button', 'd-row'); r.type = 'button';
          r.setAttribute('data-id', id); r.setAttribute('data-test', nm); r.setAttribute('data-ph', 'addon-row'); r.setAttribute('aria-pressed', 'false');
          r.innerHTML = '<span class="d-rn"><b></b><span></span></span><span class="d-rp"></span><span class="d-plus" aria-hidden="true">' + I_PL + I_CK + '</span>';
          $('.d-rn b', r).textContent = nm;
          $('.d-rp', r).textContent = ((($('.ap', a) || {}).textContent) || '').trim();
          r.addEventListener('click', function () {
            if (r.closest('.d-ghost')) return;
            var tg = modelRow(id); tg = tg && $('.atoggle', tg);
            if (!tg || tg.disabled) return;
            fire(tg);
          });
          box.appendChild(r);
        });
        frag.appendChild(cat);
      });
      return frag;
    }
    function paintTests() {
      if (!testsWrap) return;
      $$('.d-cat:not(.d-ghost) .d-row', testsWrap).forEach(function (r) {
        var a = modelRow(r.getAttribute('data-id'));
        if (!a) return;
        var on = a.classList.contains('added'), cov = a.classList.contains('covered');
        r.classList.toggle('on', on); r.classList.toggle('covered', cov);
        r.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (cov) r.setAttribute('aria-disabled', 'true'); else r.removeAttribute('aria-disabled');
        var sub = ((($('.an span', a) || {}).textContent) || '').trim(), sp = $('.d-rn span', r);
        if (sp.textContent !== sub) sp.textContent = sub;
      });
    }
    function rebuildTests() {
      if (!testsWrap) return;
      var t = T(), h0 = testsWrap.getBoundingClientRect().height;
      var olds = Array.prototype.slice.call(testsWrap.children).filter(function (e) { return !e.classList.contains('d-ghost'); });
      var frag = buildTests(), news = Array.prototype.slice.call(frag.children);
      if (!testsBuilt || t.off || !testsWrap.animate) {
        $$('.d-ghost', testsWrap).forEach(function (g) { g.remove(); });
        olds.forEach(function (e) { e.remove(); });
        testsWrap.appendChild(frag); testsBuilt = true; paintTests(); cancelA(testsWrap, 'h'); return;
      }
      var info = olds.map(function (e) { return { e: e, l: e.offsetLeft, t: e.offsetTop, w: e.offsetWidth, h: e.offsetHeight, op: curOp(e) }; });
      info.forEach(function (g) {
        var e = g.e; cancelA(e, 'in');
        e.classList.add('d-ghost'); e.setAttribute('aria-hidden', 'true'); e.setAttribute('inert', '');
        e.style.left = g.l + 'px'; e.style.top = g.t + 'px'; e.style.width = g.w + 'px'; e.style.height = g.h + 'px';
        run(e, 'out', [{ opacity: g.op }, { opacity: 0 }], { duration: t.exit, easing: 'linear', fill: 'forwards' }, function () { e.remove(); });
      });
      cancelA(testsWrap, 'h');
      testsWrap.appendChild(frag); paintTests();
      var h1 = testsWrap.getBoundingClientRect().height;
      news.forEach(function (e, i) {
        run(e, 'in', [{ opacity: 0, transform: tY(8, t) }, { opacity: 1, transform: 'none' }], { duration: t.swap, delay: t.rm ? 0 : 80 + i * 60, easing: t.easeOut, fill: 'backwards' });
      });
      if (!t.rm && Math.abs(h1 - h0) > 0.5) {
        run(testsWrap, 'h', [{ height: h0 + 'px', clipPath: 'inset(-40px -40px 0px -40px)' }, { height: h1 + 'px', clipPath: 'inset(-40px -40px -32px -40px)' }], { duration: t.swap, easing: t.easeIO });
      }
    }

    /* ---- summary card rows (desktop) ---- */
    var rowMap = {};
    if (sum) $$('.d-sr', sum).forEach(function (n) { n.remove(); });
    function syncRows() {
      if (!sum) return;
      var list = rows(), keys = list.map(function (r) { return r[0]; }), prev = $('.d-eyebrow', sum);
      Object.keys(rowMap).forEach(function (k) {
        if (keys.indexOf(k) < 0) { var e = rowMap[k]; delete rowMap[k]; collapse(e, false, false, function () { e.remove(); }); }
      });
      list.forEach(function (r) {
        var e = rowMap[r[0]];
        if (!e) {
          e = el('div', 'd-sr'); e.appendChild(el('span', null, r[1])); e.appendChild(el('b', null, money(r[2])));
          rowMap[r[0]] = e;
          if (ready) e.classList.add('d-off');
          prev.after(e);
          if (ready) collapse(e, true);
        } else { $('span', e).textContent = r[1]; $('b', e).textContent = money(r[2]); }
        prev = e;
      });
    }

    /* ---- one paint from the live state ---- */
    function render() {
      var v = view(), wb = v.base === 'wbmri';
      bases.forEach(function (b) {
        var on = b.getAttribute('data-base') === v.base;
        b.classList.toggle('sel', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
        b.tabIndex = on ? 0 : -1;
      });
      setFocusSet(wb);
      cards.forEach(function (c) { paint(c, v.focus.indexOf(c._k) > -1); });
      paint(one, v.mri);
      paintTests();
      syncRows();
      if (totAside) swapText(totAside, money(F.total()), 'right');
    }
    var pend = false;
    function schedule() { if (pend) return; pend = true; Promise.resolve().then(function () { pend = false; render(); }); }

    /* the live footer total is painted by the flow file; its old value lingers as a ghost */
    if (foot && 'MutationObserver' in window) {
      var lastFoot = foot.textContent;
      new MutationObserver(function () {
        var now = foot.textContent; if (now === lastFoot) return;
        var old = lastFoot; lastFoot = now; ghostNum(foot, old, 'left');
      }).observe(foot, { childList: true, characterData: true, subtree: true });
    }
    /* anything the live code changes on its own (A/B re-render on a base switch, the cover rule, paintBase) repaints */
    if ('MutationObserver' in window) {
      if (mRows) new MutationObserver(function (muts) {
        if (muts.some(function (m) { return m.type === 'childList' && m.target === mRows; })) rebuildTests();
        schedule();
      }).observe(mRows, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'disabled', 'hidden'] });
      if (model) new MutationObserver(schedule).observe(model, { subtree: true, attributes: true, attributeFilter: ['class', 'hidden'] });
    }

    /* "Review & book" in the card goes where the footer button goes (the A/B test arm decides it) */
    var cont = sum && $('[data-lb-continue]', sum), ffBtn = $('.flow-foot .btn');
    onArm(function (arm) {
      if (arm === 'test' || !cont || !ffBtn) return;
      cont.setAttribute('href', ffBtn.getAttribute('href') || cont.getAttribute('href'));
      var label = Array.prototype.filter.call(ffBtn.childNodes, function (n) { return n.nodeType === 3; }).map(function (n) { return n.nodeValue; }).join('').trim();
      var tn = Array.prototype.filter.call(cont.childNodes, function (n) { return n.nodeType === 3 && n.nodeValue.trim(); })[0];
      if (label && tn) tn.nodeValue = label + ' ';
    });

    /* base blurbs share one height where the cards sit side by side (Gabe's draft, 2026-10-14) */
    var bds = $$('.d-base .d-bd', B), basesWrap = $('.d-bases', B);
    function eqBase() {
      if (!basesWrap) return;
      basesWrap.style.removeProperty('--bd-h');
      var tops = bds.map(function (x) { return Math.round(x.getBoundingClientRect().top); });
      if (tops.some(function (t) { return t !== tops[0]; })) return;
      var m = 0; bds.forEach(function (x) { m = Math.max(m, x.getBoundingClientRect().height); });
      if (m) basesWrap.style.setProperty('--bd-h', m + 'px');
    }
    /* the focus heading says what the MRI case really offers (one add-on): the words swap with a 150ms fade (CSS
       .d-swapping); the copy for that case is in the section markup (data-one) */
    var fh = $('#d-focus-h', B), fhint = $('.d-fhint', B), fgrp = fh && fh.closest('.d-group');
    if (fh && fhint) { fh._multi = fh.textContent; fhint._multi = fhint.textContent; }
    var fShown = null, fTm;
    function focusHead() {
      if (!fh || !fhint) return;
      var k = focusWrap.classList.contains('one') ? 'one' : 'multi';
      if (k === fShown) return;
      var first = fShown === null; fShown = k;
      var set = function () { fh.textContent = k === 'one' ? fh.getAttribute('data-one') : fh._multi; fhint.textContent = k === 'one' ? fhint.getAttribute('data-one') : fhint._multi; };
      if (first || !ready || RMQ.matches) { clearTimeout(fTm); fgrp.classList.remove('d-swapping'); set(); return; }
      fgrp.classList.add('d-swapping'); clearTimeout(fTm);
      fTm = setTimeout(function () { set(); fgrp.classList.remove('d-swapping'); }, 150);
    }
    if ('MutationObserver' in window) new MutationObserver(focusHead).observe(focusWrap, { attributes: true, attributeFilter: ['class'] });

    /* first paint straight from the saved build, before anything shows (CSS holds .d-ent until html.lb-go) */
    render();
    focusHead(); eqBase();
    if (mRows && mRows.children.length) rebuildTests();
    H.classList.add('lb-go');
    onFlowReady(function () {
      render(); eqDesc();
      ready = true;
    });
    var eqAll = function () { eqDesc(); eqBase(); };
    window.addEventListener('resize', eqAll);
    window.addEventListener('load', eqAll);
    if (D.fonts && D.fonts.ready) D.fonts.ready.then(eqAll);
    window.HimediLB = { render: render, view: view, rows: rows };
  }

  /* ======================================================================================
     DATE STEP
     The calendar is the booking app's; the Add to Cart button is himedi-summary-next-step.js's; the rows, pills and
     sheets are himedi-summary-edit.js's (#ecCard); the held box is revealed by the flow file. This moves the button and
     the edit card into the draft's summary card (#dSum), writes the date line and the total from what those files
     show, and animates what they change.
     ====================================================================================== */
  function dateStep(R) {
    var F = window.HimediFlow;
    var sum = $('#dSum', R); if (!sum) { H.classList.add('lb-go'); return; }
    var ecSlot = $('.lb-ec', sum), act = $('#dSwap', sum), box = D.getElementById('cfCommit');
    var dateBox = $('.d-date', sum), dateB = D.getElementById('dDate');
    var totL = $('[data-lb-totl]', sum), totV = $('[data-lb-tot]', sum);
    var cal = $('.booking', R), host = $('.cf-app-slot', R);
    var EMBED = '[data-servicify="inline-calendar-embed"]';
    var MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    /* the A/B test arm has no add-ons step: the eyebrow reads Step 2 (the A/B file does this for .intro .eyebrow) */
    onArm(function (arm) {
      if (arm !== 'test') return;
      var e = $('[data-lb-step]', R);
      if (e && e.textContent.indexOf('Step 3') !== -1) e.textContent = e.textContent.replace('Step 3', 'Step 2');
    });

    /* ---- move the live nodes into the card (same nodes: every listener and reference on them keeps working) ---- */
    function adopt() {
      var q = $('.cf-quick-add');
      if (q && q.parentNode !== act) { q.classList.add('d-btn'); act.insertBefore(q, box); }
      var er = $('.cf-quick-err');
      if (er && er.parentNode !== act) act.insertBefore(er, box);
      var nx = $('.cf-next-open');
      if (nx && nx.parentNode !== act) { nx.classList.remove('btn', 'ghost'); nx.classList.add('d-pill'); act.insertBefore(nx, box); }
      var ec = D.getElementById('ecCard');
      if (ec && ec.parentNode !== ecSlot) ecSlot.appendChild(ec);
    }
    /* below 1080px the edit card renders folded behind a toggle; the draft shows its rows open at every width */
    function openFold() {
      var tg = $('[data-ec-tog]', ecSlot);
      if (tg && tg.getAttribute('aria-expanded') === 'false') tg.click();
    }
    /* the time pane only matters when a day has no slot or several; with one slot, picking the date is the choice */
    function slotCount() {
      var pane = $(EMBED + ' [data-servicify="calendar-time-picker"] .servicify-calendar-day');
      var list = pane && pane.lastElementChild;
      if (!list) return -1;
      return Array.prototype.filter.call(list.children, function (n) { return !n.hasAttribute('data-servicify') && /\d:\d\d/.test(n.textContent); }).length;
    }
    var bookedDate = null, askedBooked = false, lastPick = null;
    function readBooked() {
      if (askedBooked || !F || typeof F.pinnedDatedBooking !== 'function') return;
      askedBooked = true;
      fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.ok ? r.json() : null; }).then(function (c) {
        var l = c && F.pinnedDatedBooking(c), d = l && l.properties && String(l.properties.Date || '');
        var m = /^([A-Za-z]+)\s+(\d{1,2}),\s*(\d{4})$/.exec(d.trim());
        if (m) { bookedDate = m[1].slice(0, 3) + ' ' + m[2] + ', ' + m[3] + ' · 7–10 AM start'; sync(); }
      }).catch(function () {});
    }
    function dateText() {
      if (D.body.classList.contains('cf-booked')) { readBooked(); return bookedDate || ''; }
      if (!D.body.classList.contains('cf-quick-on')) return '';
      var sel = $(EMBED + ' .DayPicker-Day--selected'), lab = sel && sel.getAttribute('aria-label'); // "Tue Nov 10, 2026"
      var m = lab && /^[A-Za-z]+\s+([A-Za-z]+)\s+(\d{1,2}),\s*(\d{4})$/.exec(lab.trim());
      /* browsing to another month keeps the app's pick, so the line keeps it too */
      if (m) lastPick = m[1].slice(0, 3) + ' ' + m[2] + ', ' + m[3] + ' · 7–10 AM start';
      return lastPick || '';
    }
    function shown(e) { return !!e && !e.hidden && getComputedStyle(e).display !== 'none'; }

    /* ---- the action area: Add to Cart, then the held box. The button leaves as a fading ghost, the box enters ---- */
    var lastAct = null, btnSnap = null;
    function snapBtn() {
      var q = $('.cf-quick-add', act);
      if (!shown(q)) return;
      btnSnap = { html: q.outerHTML, l: q.offsetLeft, t: q.offsetTop, w: q.offsetWidth, h: q.offsetHeight };
    }
    function actState() { return shown(box) ? 'box' : (shown($('.cf-quick-add', act)) ? 'btn' : 'none'); }
    function swapAct(now) {
      var t = T();
      if (now === 'box' && lastAct === 'btn' && !t.off && box.animate) {
        if (btnSnap) {
          var wrap = D.createElement('div'); wrap.innerHTML = btnSnap.html;
          var g = wrap.firstElementChild; g.className = 'btn d-btn lb-ghost-btn'; /* not .cf-quick-add: the CSS hides that once the box is up */ g.removeAttribute('id'); g.setAttribute('aria-hidden', 'true'); g.tabIndex = -1; g.hidden = false;
          g.style.cssText = 'position:absolute;margin:0;pointer-events:none;left:' + btnSnap.l + 'px;top:' + btnSnap.t + 'px;width:' + btnSnap.w + 'px;height:' + btnSnap.h + 'px';
          act.appendChild(g);
          var a = g.animate([{ opacity: 1 }, { opacity: 0 }], { duration: t.exit, easing: 'linear', fill: 'forwards' });
          a.onfinish = function () { g.remove(); };
        }
        run(box, 'in', [{ opacity: 0, transform: tY(6, t) }, { opacity: 1, transform: 'none' }], { duration: t.swap, delay: t.rm ? 0 : 60, easing: t.easeOut, fill: 'backwards' });
      }
      lastAct = now;
    }

    /* ---- heights: a card something else re-renders tweens from its last settled height ---- */
    function settle(e) { if (!(e._m && e._m.h)) e._lastH = e.getBoundingClientRect().height; }
    function curH(e) { return (e._m && e._m.h) ? e.getBoundingClientRect().height : e._lastH; }
    function tweenCard(e, h0) {
      var t = T(); if (t.off || t.rm || !e.animate || h0 == null) return;
      cancelA(e, 'h');
      var h1 = e.getBoundingClientRect().height;
      if (Math.abs(h1 - h0) <= 0.5) return;
      e.style.overflow = 'hidden';
      run(e, 'h', [{ height: h0 + 'px' }, { height: h1 + 'px' }], { duration: t.swap, easing: t.easeIO }, function () { e.style.overflow = ''; settle(e); });
    }

    function sync() {
      var h0s = curH(sum), h0c = cal ? curH(cal) : null;
      adopt();
      openFold();
      var n = slotCount();
      R.classList.toggle('lb-pane', n === 0 || n > 1);
      /* date line */
      var dt = dateText();
      if (dt) {
        if (dateBox.hidden || dateBox.classList.contains('d-off')) { dateB.textContent = dt; dateBox.hidden = false; }
        else swapText(dateB, dt, 'left');
      } else if (!dateBox.hidden) dateBox.hidden = true;
      /* total and its label, from the edit card (it already knows earlier checkups and the held price) */
      var ec = D.getElementById('ecCard');
      if (ec) {
        var g = $('[data-ec-grand]', ec), gl = $('[data-ec-grand-label]', ec), tt = $('[data-ec-total]', ec);
        var txt = g ? g.textContent : (tt ? tt.textContent : '');
        var lab = g && gl ? gl.textContent : 'Total';
        if (totL.textContent !== lab) totL.textContent = lab;
        if (txt) { if (!totV.textContent) totV.textContent = txt; else swapText(totV, txt, 'right'); }
      } else if (F && !totV.textContent) totV.textContent = money(F.total());
      snapBtn();
      swapAct(actState());
      tweenCard(sum, h0s);
      if (cal) tweenCard(cal, h0c);
      settle(sum); if (cal) settle(cal);
    }
    var pend = false;
    function schedule() { if (pend) return; pend = true; Promise.resolve().then(function () { pend = false; sync(); }); }

    if ('MutationObserver' in window) {
      new MutationObserver(schedule).observe(D.body, { attributes: true, attributeFilter: ['class'] });
      if (host) new MutationObserver(schedule).observe(host, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'hidden', 'aria-selected', 'disabled'] });
      new MutationObserver(schedule).observe(sum, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'class', 'disabled'] });
      if (cal) new MutationObserver(schedule).observe(cal, { childList: true, subtree: true, characterData: true });
    }
    /* settled heights are taken at the end of every sync and when a tween ends (a ResizeObserver here tripped WebKit's
       "ResizeObserver loop" error, since the tween it feeds resizes the observed card); a resize or a late font re-takes them */
    var resettle = function () { settle(sum); if (cal) settle(cal); };
    window.addEventListener('resize', resettle);
    if (D.fonts && D.fonts.ready) D.fonts.ready.then(resettle);
    /* ---- month change (Gabe 2026-10-14): the draft's 120ms fade-out, then the new month fades in over --dur-swap with a
       12px slide in the direction of travel, and the month's height tweens when its row count changes. The booking app
       keeps the month in its own state: a real tap on its arrow is held for the fade-out, then passed to that same arrow
       (a script click, which this ignores). Taps during the fade are queued, not lost. Planted tokens (0ms) or reduced
       motion off-path: the tap goes straight through, as before. ---- */
    var navBusy = false, navQueue = [];
    function monthParts() { return [$(EMBED + ' .DayPicker-Caption'), $(EMBED + ' .DayPicker-Body')].filter(Boolean); }
    function capText() { var c = $(EMBED + ' .DayPicker-Caption'); return c ? c.textContent : ''; }
    function afterMonth(before, fn) {
      var done = false, mo = null, tm = null;
      var fin = function () { if (done) return; done = true; if (mo) mo.disconnect(); clearTimeout(tm); fn(); };
      if (capText() !== before) { fin(); return; }
      if ('MutationObserver' in window && host) { mo = new MutationObserver(function () { if (capText() !== before) fin(); }); mo.observe(host, { childList: true, subtree: true, characterData: true }); }
      tm = setTimeout(fin, 500);
    }
    if (host) host.addEventListener('click', function (e) {
      var nb = e.target.closest && e.target.closest('.DayPicker-NavButton');
      if (!nb || !e.isTrusted || nb.classList.contains('DayPicker-NavButton--interactionDisabled')) return;
      var t = T(); if (t.off || !nb.animate) return;
      e.preventDefault(); e.stopImmediatePropagation();
      var key = nb.classList.contains('DayPicker-NavButton--next') ? 'next' : 'prev';
      if (navBusy) { navQueue.push(key); return; }
      navBusy = true;
      var dir = key === 'next' ? 1 : -1, dx = t.rm ? 0 : dir * 12;
      var month = $(EMBED + ' .DayPicker-Month'), h0 = month ? month.getBoundingClientRect().height : 0;
      var go = function () {
        var before = capText(), q = [key].concat(navQueue); navQueue = [];
        q.forEach(function (k) { var b = $(EMBED + ' .DayPicker-NavButton--' + k); if (b && !b.classList.contains('DayPicker-NavButton--interactionDisabled')) b.click(); });
        afterMonth(before, function () {
          var m2 = $(EMBED + ' .DayPicker-Month'), h1 = m2 ? m2.getBoundingClientRect().height : 0;
          monthParts().forEach(function (x) {
            run(x, 'o', [{ opacity: 0, transform: dx ? 'translateX(' + dx + 'px)' : 'none' }, { opacity: 1, transform: 'none' }], { duration: t.swap, easing: t.easeOut });
          });
          if (!t.rm && m2 && Math.abs(h1 - h0) > 0.5) {
            m2.style.overflow = 'hidden';
            run(m2, 'h', [{ height: h0 + 'px' }, { height: h1 + 'px' }], { duration: t.swap, easing: t.easeIO }, function () { m2.style.overflow = ''; });
          }
          navBusy = false;
        });
      };
      var parts = monthParts();
      if (!parts.length) { go(); return; }
      parts.forEach(function (x, i) {
        run(x, 'o', [{ opacity: curOp(x), transform: 'none' }, { opacity: 0, transform: dx ? 'translateX(' + (-dx) + 'px)' : 'none' }], { duration: 120, easing: 'linear', fill: 'forwards' }, i === 0 ? go : null);
      });
    }, true);

    /* our own Add to Cart: the pair is not held invisible between "booked" and "held box revealed" (see the section's style) */
    act.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.cf-quick-add')) D.body.classList.add('lb-added'); }, true);
    sync();
    lastAct = actState();
    H.classList.add('lb-go');
    onFlowReady(function () {
      sync(); lastAct = actState();
      settle(sum); if (cal) settle(cal);
      /* motion starts once the page has settled on its first finished state (the pair is held invisible until then) */
      var go = function () { ready = true; };
      if (D.readyState === 'complete') setTimeout(go, 300); else window.addEventListener('load', function () { setTimeout(go, 300); });
    });
    window.HimediLBDate = { sync: sync };
  }

  var B = D.getElementById('lbB');
  if (B) builder(B);
  var Dt = D.getElementById('lbD');
  if (Dt) dateStep(Dt);
})();
